import Page from "./Page";
import Menu from "./Menu";
import Overlay from "./Overlay";

export default class Episode extends Page
{
	constructor () {

		super();

		new Menu('submenu');

		new Overlay( document.querySelector('.extra_list') );
	}
}